import { render, staticRenderFns } from "./CalendarRangesController.vue?vue&type=template&id=8363c5e6&scoped=true&"
import script from "./CalendarRangesController.vue?vue&type=script&lang=js&"
export * from "./CalendarRangesController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8363c5e6",
  null
  
)

export default component.exports